/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Nothing_LeftInputs */

const vi_sales_return_nothing_left = /** @type {(inputs: Sales_Return_Nothing_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã trả hết hàng, không còn gì để trả.`)
};

/**

* @param {Sales_Return_Nothing_LeftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_nothing_left = /** @type {((inputs?: Sales_Return_Nothing_LeftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Nothing_LeftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_nothing_left(inputs)
});